module.exports = __webpack_public_path__ + "img/1541716443.6652d91d.jpg";